<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn color="primary" x-small text @click="() => $router.push({ name: 'turmas' })">
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          Quadro de Horário Turma:
          {{ turma ? turma?.descricao : "[NÃO INFORMADO]" }}
        </h1>

        <div v-if="gestoesDeAulas.length === 0" style="text-align: center">
          <v-alert color="warning" icon="fa fa-frown-o"
            >Nenhum Quadro de Horário disponível para esta turma.</v-alert
          >
        </div>

        <v-simple-table v-else>
          <thead>
            <tr>
              <th style="text-align: center">Dia/Horário</th>
              <th
                v-for="(horario, idx) in horariosUnicos"
                :key="`horario-${horario.id}-${idx}`"
                style="text-align: center"
              >
                {{ horario.descricao }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(dia, index) in diasUnicos" :key="index">
              <td class="dia-coluna">
                <span class="dia-abreviado">{{ dia.descricao.slice(0, 3) }}</span>
                <span class="dia-completo">{{ dia.descricao }}</span>
              </td>
              <td
                v-for="(horario, i) in horariosUnicos"
                :key="`cell-${dia.id}-${horario.id}-${i}`"
                :class="{
                  'multiple-classes': getTodasTurmasDisciplinas(dia.id, horario.id).length > 1,
                  'has-content': getTodasTurmasDisciplinas(dia.id, horario.id).length > 0,
                }"
                :style="
                  getTodasTurmasDisciplinas(dia.id, horario.id).length === 1
                    ? {
                        backgroundColor: getCorPorDisciplina(
                          getTodasTurmasDisciplinas(dia.id, horario.id)[0].disciplina
                        ),
                      }
                    : {}
                "
              >
                <div
                  v-for="(aula, idx) in getTodasTurmasDisciplinas(dia.id, horario.id)"
                  :key="`aula-${idx}`"
                  class="aula-item"
                  :style="
                    getTodasTurmasDisciplinas(dia.id, horario.id).length > 1
                      ? { backgroundColor: getCorPorDisciplina(aula.disciplina) }
                      : {}
                  "
                >
                  {{ aula.disciplina }}<br />
                  <small>{{ aula.professor }}</small>
                </div>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
        <v-row class="no-print mt-3">
          <v-col class="text-right">
            <v-btn color="primary" @click="imprimirQuadro">
              <v-icon left>mdi-printer</v-icon>
              Imprimir Quadro
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </main-template>
</template>

<script>
export default {
  data() {
    return {
      turma: null,
      gestoesDeAulas: [],
      horariosUnicos: [],
      diasUnicos: [],
      diasDaSemana: [
        { id: "Segunda-feira", descricao: "Segunda-feira", ordem: 1 },
        { id: "Terça-feira", descricao: "Terça-feira", ordem: 2 },
        { id: "Quarta-feira", descricao: "Quarta-feira", ordem: 3 },
        { id: "Quinta-feira", descricao: "Quinta-feira", ordem: 4 },
        { id: "Sexta-feira", descricao: "Sexta-feira", ordem: 5 },
        { id: "Sábado", descricao: "Sábado", ordem: 6 },
      ],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      try {
        this.$loaderService.open("Carregando Quadro de Horário");
        const { turma_id } = this.$route.params;
        const data = await this.$services.turmasService.quadroHorario(turma_id);

        this.turma = data;
        this.gestoesDeAulas = data.gestao_de_aulas;
        this.processarGestaoDeAulas();
        this.$loaderService.close();
      } catch (error) {
        this.$handleError(error);
      }
    },
    processarGestaoDeAulas() {
      const dias = new Map();
      const horariosMap = new Map();

      this.gestoesDeAulas.forEach((gestao) => {
        gestao.relacoesDiasHorarios.forEach((relacao) => {
          const diaIdNormalizado = relacao.dia.descricao.trim();

          if (!dias.has(diaIdNormalizado)) {
            const diaConfig = this.diasDaSemana.find(
              (d) => d.id === relacao.dia.id || d.descricao === diaIdNormalizado
            );
            dias.set(diaIdNormalizado, {
              id: diaIdNormalizado,
              descricao: diaIdNormalizado,
              ordem: diaConfig ? diaConfig.ordem : 99,
            });
          }

          if (!horariosMap.has(relacao.horario.id)) {
            horariosMap.set(relacao.horario.id, {
              id: relacao.horario.id,
              descricao: relacao.horario.descricao,
            });
          }
        });
      });

      this.diasUnicos = Array.from(dias.values()).sort((a, b) => a.ordem - b.ordem);
      this.horariosUnicos = Array.from(horariosMap.values()).sort((a, b) => a.id - b.id);
    },

    getTodasTurmasDisciplinas(diaId, horarioId) {
      const gestoesEncontradas = this.gestoesDeAulas.filter((gestao) =>
        gestao.relacoesDiasHorarios.some(
          (relacao) => relacao.dia.descricao.trim() === diaId && relacao.horario.id === horarioId
        )
      );

      return gestoesEncontradas.map((gestao) => {
        let disciplinaNome = "Polivalência";
        if (gestao.disciplina) {
          disciplinaNome = gestao.disciplina.sigla || gestao.disciplina.descricao || "Polivalência";
        }

        return {
          turma: gestao.turma?.descricao || "Turma não definida",
          disciplina: disciplinaNome,
          professor: gestao.professor?.nome || "Professor nao definido",
        };
      });
    },

    getTurmaDisciplina(diaId, horarioId, index = 0) {
      const gestoesEncontradas = this.gestoesDeAulas.filter((gestao) =>
        gestao.relacoesDiasHorarios.some(
          (relacao) => relacao.dia.id === diaId && relacao.horario.id === horarioId
        )
      );

      const gestaoEncontrada = gestoesEncontradas[index];

      if (gestaoEncontrada) {
        let disciplinaNome = "Polivalência";
        if (gestaoEncontrada.disciplina) {
          disciplinaNome =
            gestaoEncontrada.disciplina.sigla ||
            gestaoEncontrada.disciplina.descricao ||
            "Polivalência";
        }

        return {
          turma: gestaoEncontrada.turma?.descricao || "Turma não definida",
          disciplina: disciplinaNome,
        };
      }

      return null;
    },

    async imprimirQuadro() {
      try {
        const { turma_id } = this.$route.params;
        this.$loaderService.open("Carregando dados...");
        await this.$services.turmasService.imprimirQuadroHorarioTurma(turma_id);
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    getCorPorDisciplina(disciplina) {
      const corPorDisciplina = {
        // Línguas - tons de laranja/pêssego
        "Língua Portuguesa": "#FFCC99",
        "Língua Inglesa": "#FFD6A5",
        "ESTUDO ORIENTADO DE  LÍNGUA PORTUGUESA": "#FFB86C", // tom mais escuro de laranja
        "LINGUA ESTRANGEIRA - INGLES": "#FFEAD0", // tom mais claro

        // Matemática - tons de amarelo
        Matemática: "#FDFFB6",
        "ESTUDO ORIENTADO DE MATEMÁTICA": "#FFF59D", // tom mais vibrante

        // Ciências - tons de verde
        Ciências: "#A2E4B8",
        "Iniciação Cientifica": "#C8E6C9", // tom mais claro
        "INICIAÇÃO CIENTIFÍCA": "#C8E6C9",
        "HORTA ESCOLAR": "#81C784", // verde mais forte

        // Humanas - tons de azul
        História: "#99D1FF",
        Geografia: "#A0C4FF",

        // Artes e Expressão - tons de verde claro/menta
        Artes: "#B9FBC0",
        MÚSICA: "#A7F3D0",
        "do Livro ao Palco": "#D4F1F4",
        "TRAÇOS, SONS, CORES E FORMAS": "#B2F5EA",

        // Educação Física e Movimento - tons de ciano/turquesa
        "Educação Física": "#98F5E1",
        Esporte: "#7FDBDA",
        CAPOEIRA: "#5FD3D1",
        "CORPO, GESTOS E MOVIMENTOS": "#81E6D9",
        "SAÚDE, CORPO E MENTE": "#A0E7E5",

        // Desenvolvimento Pessoal - tons de roxo/lilás
        "Ensino Religioso": "#E2D1F9",
        "PROJETO DE VIDA": "#D4BBFF",
        EMPREENDEDORISMO: "#C4A7E7",

        // Educação Infantil - tons de rosa
        "Educação Infantil": "#FFC6FF",
        "Ensino Infantil": "#FFC6FF",
        "ESPAÇOS, TEMPOS, QUANTIDADES RELAÇÕES E TRANSFORMAÇÕES": "#FFB3E6",
        "O EU, O OUTRO E O NÓS": "#FFD4F4",
        "ESCUTA, FALA, PENSAMENTO E IMAGINAÇÃO": "#FFABE1",

        // Polivalência - cinza
        Polivalência: "#E2E2E2",
      };
      const corDisciplina = Object.keys(corPorDisciplina).find((key) => disciplina.includes(key));
      return corDisciplina ? corPorDisciplina[corDisciplina] : "#ffffff";
    },
  },
};
</script>

<style scoped>
th {
  text-align: center;
  background-color: #e0e0e0;
  padding: 10px;
}
td {
  text-align: center;
  padding: 0;
  border: 1px solid #ccc;
  vertical-align: middle;
}

.multiple-classes {
  padding: 0 !important;
}

.aula-item {
  padding: 10px;
  margin: 0;
  width: 100%;
  box-sizing: border-box;
  min-height: 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.aula-item:last-child {
  border-bottom: none;
}

td:not(.dia-coluna) {
  padding: 0 !important;
  height: 100%;
}

td:not(.dia-coluna):has(> div:only-child) {
  height: 100%;
}

td:not(.dia-coluna) > div:only-child {
  height: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.coluna-duplicada {
  border-left: 3px solid #fb9716 !important;
}

.dia-completo {
  display: none;
}

.dia-abreviado {
  display: inline;
}

@media print {
  .no-print,
  .v-navigation-drawer,
  .v-app-bar,
  .v-footer,
  button {
    display: none !important;
  }

  .v-main {
    padding: 0 !important;
  }

  table {
    width: 100% !important;
    border-collapse: collapse !important;
    page-break-inside: avoid;
  }

  td {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  th {
    background-color: #fb9716 !important;
    color: white !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    font-weight: bold;
  }

  th,
  td {
    border: 1px solid #333 !important;
    padding: 8px !important;
  }

  h1 {
    font-size: 18pt;
    margin-bottom: 10px;
    color: #000;
  }

  .v-simple-table {
    page-break-after: always;
  }

  .dia-abreviado {
    display: none;
  }

  .dia-completo {
    display: inline;
  }
}
</style>
